import React from "react";
import { connect } from "react-redux";
import { IAppState } from "../state/interfaces";
import { QUOTE_STEPS } from "../AppConstants";

interface IProps {
    progress: 0
}

class Progress extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="quote-progress">
                <div className="steps">
                    {/*<div className="row step-names">*/}
                    {/*    <div className="col-3 text-center">Cars</div>*/}
                    {/*    <div className="col-3 text-center">Drivers</div>*/}
                    {/*    <div className="col-3 text-center">Insurance</div>*/}
                    {/*    <div className="col-3 text-center">Quotes</div>*/}
                    {/*</div>*/}
                    {/*<div className="progress" style={{ height: 4 }}>*/}
                    {/*    <div className="progress-bar" role="progressbar" style={{ width: this.props.progress + '%' }}></div>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
}

function calculateProgress(currentStep: string) {
    switch (currentStep) {
        case QUOTE_STEPS.VEHICLE_YMM:
            return 10;
        case QUOTE_STEPS.VEHICLE_DETAILS:
            return 20;
        case QUOTE_STEPS.HOW_YOU_DRIVE:
            return 25;
        case QUOTE_STEPS.ABOUT_YOU:
            return 30;
        case QUOTE_STEPS.EDUCATION_EMPLOYMENT:
            return 35;
        case QUOTE_STEPS.YOUR_HOME:
            return 40;
        case QUOTE_STEPS.YOUR_LICENSE:
            return 45;
        case QUOTE_STEPS.DRIVING_HISTORY:
            return 50;
        case QUOTE_STEPS.CURRENT_INSURANCE:
            return 55;
        case QUOTE_STEPS.INSURANCE_HISTORY:
            return 65;
        case QUOTE_STEPS.NEW_POLICY:
            return 75;
        case QUOTE_STEPS.CONTACT_INFO:
            return 90;
        case QUOTE_STEPS.COVERAGES:
            return 100;
        default:
            return 5;
    }
}

let mapProps = (state: IAppState) => {
    return {
        progress: calculateProgress(state.currentStep)
    }
}

let mapDispatch = (dispatch: any) => {
    return {
    }
}

export default connect(mapProps)(Progress)
